import "./App.css";
import NavBar from "./component/NavBar";
import BodyContent from "./component/BodyContent";
import Footer from "./component/Footer";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import ThankYouScreen from "./component/ThankYouScreen";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Chatbot from"./component/Chatbot"

const App = () => {
  return (
    <Router>
      <MainApp />
      <Chatbot />
    </Router>
  );
};

const MainApp = () => {
  const location = useLocation();

  return (
    <>
      <NavBar />
      <Routes>
        <Route path="/" element={<BodyContent />} />
        <Route path="/thank-you" element={<ThankYouScreen />} />
      </Routes>
      {location.pathname !== "/thank-you" && <Footer />}
    </>
  );
};
export default App;
